import { FelaCSS, colors, spacing } from '@bridebook/ui';
import { APP_BAR_MOBILE_BASIC_OFFSET } from '@bridebook/web/components/app-bar/app-bar-mobile/basic/app-bar-mobile-basic';

interface IStyles {
  contentWrapper: FelaCSS;
  content: FelaCSS;
  mobile: {
    wrapper: FelaCSS;
    header: FelaCSS;
    title: FelaCSS;
    closeIcon: FelaCSS;
    backIcon: FelaCSS;
  };
  desktop: {
    header: FelaCSS;
    headerBottomBorder: FelaCSS;
    titleText: FelaCSS;
    modalStyle: FelaCSS;
    buttonStyle: FelaCSS;
    backIcon: FelaCSS;
  };
  footer: FelaCSS;
}

const styles: IStyles = {
  contentWrapper: {
    flex: 1,
    overflow: 'auto',
    width: '100%',
  },
  content: {
    alignItems: 'center',
    marginHorizontal: 'auto',
    minWidthDesktop: {
      padding: spacing[4],
    },
    width: '100%',
  },
  mobile: {
    wrapper: {
      background: colors.white,
      minHeight: '100dvh',
      maxHeight: '100dvh',
      supportsSafeAreaInset: {
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      },
    },
    header: {
      height: APP_BAR_MOBILE_BASIC_OFFSET,
      background: colors.white,
      borderBottom: `1px solid ${colors.space15}`,
    },
    title: {
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      color: colors.space,
      fontDefaultSemiBold: 16,
    },
    closeIcon: {
      position: 'absolute',
      top: '50%',
      right: '16px',
      transform: 'translateY(-50%)',
      alignItems: 'center',
      justifyContent: 'center',
      height: '32px',
      width: '32px',
      cursor: 'pointer',
    },
    backIcon: {
      position: 'absolute',
      top: '50%',
      left: 12,
      transform: 'translateY(-50%) rotate(90deg)',
      alignItems: 'center',
      justifyContent: 'center',
      background: colors.space04,
      borderRadius: 32,
      height: 32,
      width: 32,
      cursor: 'pointer',
      zIndex: 999,
    },
  },
  desktop: {
    header: {
      paddingTop: spacing[6],
      paddingBottom: spacing[6],
      width: '100%',
      transition: 'border-bottom 0.2s ease-in-out',
      borderBottom: `1px solid transparent`,
    },
    headerBottomBorder: {
      borderBottom: `1px solid ${colors.space15}`,
    },
    titleText: {
      fontPlayfair: 28,
      color: colors.space,
      textAlign: 'center',
      fontWeight: 800,
    },
    modalStyle: {
      maxWidth: 'auto',
      width: '100%',
      padding: 0,
      overflow: 'auto',
      alignItems: 'center',
      maxHeight: 'calc(100vh - 100px)',
    },
    buttonStyle: {
      position: 'fixed',
      top: 0,
      right: 0,
    },
    backIcon: {
      position: 'absolute',
      top: '50%',
      left: 16,
      transform: 'translateY(-50%) rotate(90deg)',
      alignItems: 'center',
      justifyContent: 'center',
      background: colors.white,
      borderRadius: 32,
      height: 32,
      width: 32,
      cursor: 'pointer',
      border: `1px solid ${colors.space15}`,
      zIndex: 999,
    },
  },
  footer: {
    width: '100%',
    background: colors.white,
    padding: spacing[4],
    borderTop: `1px solid ${colors.space15}`,
  },
};

export default styles;
